import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_IDVERIFY_SUCCESS:
      return action.idVerify;
    default:
      return state;
  }
}
